(function() { window.GUID_7676cc0b_07fc_4eae_a017_c2b5ef46fec4 = { getGuid: function() { return "7676cc0b-07fc-4eae-a017-c2b5ef46fec4"; } }; })();
var ScoreSheetAdvanced;
(function (ScoreSheetAdvanced) {
    var advancedPlayerListLeft;
    var advancedPlayerListRight;
    var scoreSheetAdvanced;
    var advancedBtnOk = null;
    var advancedBtnCancel = null;
    var advancedEncounterRowId = null;
    CS.FormReady(function (formId) {
        var actualForm = this;
        if (formId == "ScoreSheetAdvanced") {
            scoreSheetAdvanced = $('#ScoreSheetAdvanced');
            advancedPlayerListLeft = $('#PlayerListLeft');
            advancedPlayerListRight = $('#PlayerListRight');
            advancedEncounterRowId = $('#ScoreSheetAdvancedEncounterRowId');
            $('#TableScoreSheetAdvanced', scoreSheetAdvanced).on('dblclick', '.PlayerName', function (e) {
                var $target = $(e.target);
                var actualList = null;
                ClearAdvancedControls();
                if ($target.hasClass('DisplayedPlayerName')) {
                    $target = $target.parent();
                }
                if ($target.hasClass('L')) {
                    advancedPlayerListLeft.detach().appendTo($target);
                    actualList = advancedPlayerListLeft;
                }
                else if ($target.hasClass('R')) {
                    advancedPlayerListRight.detach().appendTo($target);
                    actualList = advancedPlayerListRight;
                }
                advancedBtnOk = $('<button>OK</button>');
                advancedBtnCancel = $('<button>Cancel</button>');
                advancedBtnOk.appendTo($target);
                advancedBtnCancel.appendTo($target);
                actualList.show();
                advancedBtnOk.on('click', function (e) {
                    e.preventDefault();
                    var data = {
                        gameId: $target.data('gameid'),
                        oldEntityBaseId: $target.data('entityid'),
                        newEntityBaseId: actualList.val(),
                        encounterRowId: advancedEncounterRowId.val(),
                    };
                    CompuSport.Ajax.Post(CSParameters.RUrl + 'Scores/UpdateScoreSheetAdvanced/' + CSParameters.SportEventId, data, function (response) {
                        if (response != "") {
                            $('.DisplayedPlayerName', $target).html(response);
                            $target.data('entityid', data.newEntityBaseId);
                        }
                        ClearAdvancedControls();
                    });
                });
                advancedBtnCancel.on('click', function (e) {
                    e.preventDefault();
                    ClearAdvancedControls();
                });
            });
        }
    });
    function ClearAdvancedControls() {
        advancedPlayerListLeft.hide();
        advancedPlayerListRight.hide();
        if (advancedBtnOk != null) {
            advancedBtnOk.remove();
            advancedBtnCancel.remove();
        }
    }
})(ScoreSheetAdvanced || (ScoreSheetAdvanced = {}));

//# sourceMappingURL=ScoreSheetAdvanced.js.map
